"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = Checkbox;
exports.CheckboxState = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("./styles");
var _common = require("../styles/common");
require("../utils/setupCheckbox");
const _excluded = ["state", "onClick", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// The true,false,mixed options match the ARIA specification checkbox states
const CheckboxState = {
  ON: "true",
  OFF: "false",
  MIXED: "mixed"
};
exports.CheckboxState = CheckboxState;
const StyledCheckbox = _styledComponents.default.div`
    ${_styles.checkboxWrapper}
    ${props => props.disabled && _common.disabled}

    ::after {
        ${({
  state
}) => state === CheckboxState.ON && _styles.checkboxOn}
        ${({
  state
}) => state === CheckboxState.MIXED && _styles.checkboxMixed}
    }
`;

// TODO: Consider label options by id (htmlFor).

function Checkbox(_ref) {
  let {
      state,
      onClick,
      disabled
    } = _ref,
    extra = _objectWithoutProperties(_ref, _excluded);
  const handleClick = () => {
    !disabled && onClick(
    // This handles the default toggling of a checkbox, switching alternatively On and Off.
    // If you want cunstom logic, just ignore the parameter that is passed to the onClick
    [CheckboxState.ON, CheckboxState.MIXED].includes(state) ? CheckboxState.OFF : CheckboxState.ON);
  };
  return /*#__PURE__*/_react.default.createElement(StyledCheckbox, _extends({
    state: state,
    onClick: handleClick,
    tabIndex: 0 // Make it focusable with Tab key
    ,
    onKeyDown: ({
      code
    }) => code === "Space" && handleClick(),
    role: "checkbox",
    disabled: disabled,
    "aria-disabled": disabled,
    "aria-checked": state
  }, extra));
}
Checkbox.defaultProps = {
  state: CheckboxState.OFF,
  onClick: state => console.log(state),
  title: "checkbox",
  disabled: false
};
Checkbox.propTypes = {
  state: _propTypes.default.oneOf(Object.values(CheckboxState)),
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
};